import { css, Interpolation, Theme } from '@emotion/react'
import { autocompleteClasses } from '@mui/material/Autocomplete'

export const wrapper: Interpolation<Theme> = css`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const questionTitle: Interpolation<Theme> = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  max-height: 20px;
`

export const badge: Interpolation<Theme> = css`
  flex: none;
`

export const badges: Interpolation<Theme> = css`
  max-width: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: right;
  gap: 4px;
`

export const badgeInner: Interpolation<Theme> = css`
  width: fit-content;
`

export const search: Interpolation<Theme> = css`
  max-width: 850px;
`

export const withPlatformsStyles: Interpolation<Theme> = (theme: Theme) => css`
  .${autocompleteClasses.option} {
    .platforms-wrapper {
      position: relative;
      display: flex;
      gap: 8px;
      max-width: 50%;
      padding-left: 20px;
      overflow: hidden;
      justify-content: end;

      &::before {
        content: '';
        background: linear-gradient(90deg, ${theme.backgrounds.backgroundFour} 0%, transparent 100%);
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 20px;
        z-index: 1;
      }
    }

    &.${autocompleteClasses.focused}, &[aria-selected='true'], &.${autocompleteClasses.focused}[aria-selected="true"] {
      .platforms-wrapper::before {
        background: linear-gradient(90deg, ${theme.colors.grayHover} 0%, transparent 100%);
      }
    }
  }
`
